import { useMutation } from '@apollo/client'
import { AddTest, AddTestVariables } from '../../types'
import { ADD_TEST_MUTATION } from './operations'

export const useAddTest = () => useMutation<AddTest, AddTestVariables>(ADD_TEST_MUTATION)
